import React from 'react';
import Enhance from '../core/enhance';
import Component from '../core/component';
import Lock from './lock'

window.modalIndex = 0;

/**
 *
 */
class Modal extends Component {

    state = {
        component: {},
        modals: {}
    };

    constructor(props) {
        super(props);
    }

    /**
     * 挂载
     */
    componentDidMount() {
        this._on('Modal', this.handlerCheckComponent);
    }

    /**
     * 卸载
     */
    componentWillUnmount() {
        this._un('Modal', this.handlerCheckComponent);
    }


    render() {
        return (
            <div className="c-modal">
                {this.renderComponents()}
            </div>
        )
    }


    /**
     *
     * @param view
     * @param uuid
     * @private
     */
    handlerCheckComponent = (view, uuid) => {
        if (view) {
            this.state.modals[uuid] = view;
            this.forceUpdate(() => {
                this.refs[uuid] && this.refs[uuid].update();
            })
        } else {
            if (this.refs[uuid]) {
                delete this.state.modals[uuid];
                this.forceUpdate();
            }
        }
    }

    /**
     *
     * @returns {Array}
     * @private
     */
    renderComponents() {
        let {modals} = this.state;
        let views = [];
        $.each(modals, (uuid, view) => {
            views.push(<Lock key={uuid} ref={uuid}>{view}</Lock>);
        });
        return views;
    }

}

Modal = Enhance(Modal, {}, 'Modal');
export default Modal